import styled from 'styled-components';

export const AccountAccessWrapper = styled('div')`
  position: relative;
`;

export const AccountAccess = styled.div`
  position: relative;
  height: ${({ theme }) => theme.x8space * 10}px;
  line-height: ${({ theme }) => (theme.x8space - 0.2) * 10}px;
  padding-right: ${({ theme }) => theme.x3spacePx}px;
  padding-left: ${({ theme }) => theme.x1spacePx}px;
  user-select: none;
  cursor: pointer;
`;

export const User = styled.span`
  ${({ theme }) => theme.typography.xSmall}
  margin: 0 ${({ theme }) => theme.x1spacePx}px 0;
  > svg {
    width: 18px;
    height: 18px;
    margin-bottom: -3px;
    margin-left: 4px;
    > * {
      fill: white;
    }
  }
`;

export const Chevron = styled.span`
  margin: 0 ${({ theme }) => theme.x1spacePx / 2}px;
  > svg {
    width: 12px;
    height: 12px;
    > * {
      fill: white;
    }
  }
`;

export const Click = styled.button`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
`;
